/* eslint-disable react/default-props-match-prop-types */
import { MouseEvent, CSSProperties } from "react";
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
// import "./CTAButton.css";

export type CTAButtonProps = {
    primary: boolean;
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    ariaLabel?: string;
    label?: string;
    intlKey?: string;
    parentNode?: string;
    className?: string;
    style?: CSSProperties;
    disabled?: boolean;
}

const CTAButton = (props:CTAButtonProps) => {
    const { onClick, primary, intlKey, style, parentNode, className, ariaLabel, label, ...rest } = props;
    const parentKey = parentNode || "PAUSE_MENU";
    const { __t } = useTranslation(parentKey);
    const btnClassName = primary ? "primary-cta-btn" : "secondary-cta-btn";
    const intlValues = __t(intlKey, parentKey);
    const btnLabel = intlValues?.label ?? (__t(label) || label);
    const btnArialLabel = intlValues?.ariaLabel ?? (__t(ariaLabel) || ariaLabel);
    return  <button type="button" className={`${btnClassName} cta-btn ${className}`} aria-label={btnArialLabel} onClick={onClick}
        style={style} {...rest}
    >
        <span className="cta-btn-txt">{btnLabel}</span>
    </button>;
};

CTAButton.defaultProps = {
    primary: false,
    onClick: () => {}
};

export default CTAButton;
